import { addons } from '@storybook/addons';

addons.setConfig({
  sidebar: {
    showRoots: true,
  },
});
